/**
 * CleanCard component.
 */
import Card from '@shared/types/props/card';
import HorizontalCard from './horizontalCard';
import { memo } from 'react';

function CleanCard(parentProps: Card) {
  return <HorizontalCard {...parentProps} showInfo={false} showMask={false} />;
}

export default memo(CleanCard);
